import React, { Component } from 'react'

class ProjectPartner extends Component {
    render(){
        return(


    <div className='w3-row w3-center'>
        <h4><b>Project Partner Institutes</b></h4>
    <div className='w3-row w3-container w3-padding'>
        <div className="w3-third w3-container w3-margin-bottom">
            
            <div className="w3-card-2 w3-white w3-round-large w3-center my-card-pad" >
                            <div className="w3-container">
                            <img src="./images/iitr.png" alt='IIT Roorkee' class="w3-circle w3-hover-opacity my-card-img" />
                            </div>
                            <div className="w3-container w3-row w3-padding">
                                
                                 
                                    <div className="w3-large"><b>Indian Institute of Technology Roorkee, India</b></div>
                               
                         
                            </div>            
                        </div>   
        </div>
        <div className="w3-third  w3-container w3-margin-bottom">
        <div className="w3-card-2 w3-white w3-round-large w3-center my-card-pad" >
                            <div className="w3-container">
                            <img src="./images/dei.png" alt='DEI Agra' class="w3-circle w3-hover-opacity my-card-img" />
                            </div>
                            <div className="w3-container w3-row w3-padding">
                                
                                 
                                    <div className="w3-large"><b>Dayalbagh Educational Institute Agra, India</b></div>
                               
                         
                            </div>            
                        </div>  

  
        </div>    
        <div className="w3-third  w3-container w3-margin-bottom">

        <div className="w3-card-2 w3-white w3-round-large w3-center my-card-pad" >
                            <div className="w3-container">
                            <img src="./images/uit.png" alt='UiT Norway' class="w3-circle w3-hover-opacity my-card-img" />
                            </div>
                            <div className="w3-container w3-row w3-padding">
                                
                                 
                                    <div className="w3-large"><b>UiT The Arctic University of Norway, Norway</b></div>
                               
                         
                            </div>            
                        </div>  


              
        </div>          

  
  
    
        
    </div> 
    </div>

            
        )
    }
}

export default ProjectPartner